import { render, staticRenderFns } from "./ProtocolSign.vue?vue&type=template&id=d79ff3f2&scoped=true&"
import script from "./ProtocolSign.vue?vue&type=script&lang=js&"
export * from "./ProtocolSign.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolSign.vue?vue&type=style&index=0&id=d79ff3f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79ff3f2",
  null
  
)

export default component.exports